import { Utils } from 'src/utilities/Utils';
import { Employee, IEmployee } from "@/model/Employee";
import { mapData } from '@/utilities/DataMapping';

export interface IEmployeeVM {

    status: string;
    createdBy: string;
    lastUpdatedBy: string;

    employee: IEmployee;
}

export class EmployeeVM implements IEmployeeVM {

    constructor(data?: IEmployeeVM) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IEmployeeVM) {
        mapData(data, {
            root: () => this,
            employee: () => new Employee()
        });
    }

    status: string = "";
    createdBy: string = "";
    lastUpdatedBy: string = "";

    employee: any = new Employee;

    get searchDetail() {
        return this.employee.fullname + ', ' + this.employee.sentinelID + ', ' + this.employee.contactNumber;
    }
}